interface TagProps {
  name: string | undefined;
  yes?: boolean;
}

const Tag: React.FC<TagProps> = ({ name, yes = false }) => {
  return (
    <>
      <div
        className={`flex justify-center items-center pb-8 md:pb-20  ${
          yes ? "md:pt-8 md:pb-8" : "lg:pt-28 md:pt-20 pt-16 md:pb-20"
        } `}
      >
        <hr className="  ltr:mr-3 rtl:ml-3 md:w-24 xs:w-16 w-12 border-t-4  xs:border-t-8 border-primary" />
        <h3 className="md:text-[42px] text-[26px] text-center font-bold font-Helvetica_Neue">
          {name?.toUpperCase()}
        </h3>
        <hr className=" ltr:ml-3 rtl:mr-3 md:w-24 xs:w-16 w-12 border-t-4  xs:border-t-8 border-primary" />
      </div>
    </>
  );
};

export default Tag;
